import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation deleteSystemRole($id: String!) {
    deleteSystemRole(id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const deleteSystemRoleRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_role/delete_system_role',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.deleteSystemRole;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const deleteSystemRoleSlice = createSlice({
  name: 'delete_system_role',
  initialState: initialState,
  reducers: {
    deleteSystemRoleClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(deleteSystemRoleRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(deleteSystemRoleRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(deleteSystemRoleRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { deleteSystemRoleClear } = deleteSystemRoleSlice.actions;

export const deleteSystemRole = createSelector(
  (state: RootState) => state.systemRole.deleteSystemRole.result,
  (state: RootState) => state.systemRole.deleteSystemRole.error,
  (state: RootState) => state.systemRole.deleteSystemRole.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default deleteSystemRoleSlice.reducer;